import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", {
        width: "58",
        height: "58",
        viewBox: "0 0 58 58",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                filter: "url(#filter0_d_176_2805)",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        x: "11",
                        y: "6",
                        width: "36",
                        height: "36",
                        rx: "12",
                        fill: "#194BFB",
                        shapeRendering: "crispEdges"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M25.7499 17C25.7499 16.5858 25.4141 16.25 24.9999 16.25C24.5857 16.25 24.2499 16.5858 24.2499 17L25.7499 17ZM22.3977 29.2105L21.865 29.7385H21.865L22.3977 29.2105ZM21.5326 27.2722C21.241 26.978 20.7661 26.9759 20.4719 27.2674C20.1777 27.559 20.1756 28.0339 20.4672 28.3281L21.5326 27.2722ZM35.602 18.5893L36.1347 18.0613V18.0613L35.602 18.5893ZM36.4672 20.5276C36.7588 20.8218 37.2336 20.824 37.5278 20.5324C37.822 20.2408 37.8242 19.7659 37.5326 19.4717L36.4672 20.5276ZM33.2505 16.8156L33.3454 16.0716L33.3454 16.0716L33.2505 16.8156ZM32.2499 31C32.2499 31.4142 32.5857 31.75 32.9999 31.75C33.4141 31.75 33.7499 31.4142 33.7499 31H32.2499ZM33.1999 16.8098L33.1242 17.556L33.1999 16.8098ZM24.9999 30.7487H24.2499H24.9999ZM25.7499 30.7487L25.7499 17L24.2499 17L24.2499 30.7487H25.7499ZM22.9304 28.6825L21.5326 27.2722L20.4672 28.3281L21.865 29.7385L22.9304 28.6825ZM21.865 29.7385C22.41 30.2883 22.8625 30.7465 23.2671 31.0714C23.6835 31.4059 24.1212 31.6602 24.6544 31.7282L24.844 30.2402C24.6979 30.2216 24.5172 30.1515 24.2064 29.9019C23.8837 29.6428 23.5002 29.2574 22.9304 28.6825L21.865 29.7385ZM35.0693 19.1173L36.4672 20.5276L37.5326 19.4717L36.1347 18.0613L35.0693 19.1173ZM36.1347 18.0613C35.5898 17.5115 35.1372 17.0533 34.7326 16.7284C34.3162 16.3939 33.8786 16.1396 33.3454 16.0716L33.1557 17.5596C33.3019 17.5782 33.4826 17.6483 33.7934 17.8979C34.116 18.157 34.4995 18.5424 35.0693 19.1173L36.1347 18.0613ZM33.1242 17.556C33.1347 17.557 33.1452 17.5582 33.1557 17.5596L33.3454 16.0716C33.3221 16.0687 33.2988 16.066 33.2755 16.0636L33.1242 17.556ZM32.2499 17V31H33.7499V17H32.2499ZM33.2755 16.0636C32.6727 16.0025 32.2499 16.498 32.2499 17L33.7499 17C33.7499 17.2807 33.5069 17.5948 33.1242 17.556L33.2755 16.0636ZM24.2499 30.7487C24.2499 30.5034 24.4688 30.1924 24.844 30.2402L24.6544 31.7282C25.305 31.8111 25.7499 31.2716 25.7499 30.7487H24.2499Z",
                        fill: "#FAFAFA"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("filter", {
                    id: "filter0_d_176_2805",
                    x: "0",
                    y: "0",
                    width: "58",
                    height: "58",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ _jsx("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            in: "SourceAlpha",
                            type: "matrix",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            result: "hardAlpha"
                        }),
                        /*#__PURE__*/ _jsx("feOffset", {
                            dy: "5"
                        }),
                        /*#__PURE__*/ _jsx("feGaussianBlur", {
                            stdDeviation: "5.5"
                        }),
                        /*#__PURE__*/ _jsx("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ _jsx("feColorMatrix", {
                            type: "matrix",
                            values: "0 0 0 0 0.0980392 0 0 0 0 0.294118 0 0 0 0 0.984314 0 0 0 0.4 0"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_176_2805"
                        }),
                        /*#__PURE__*/ _jsx("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_176_2805",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });
};
export default Icon;
